import React from "react";

interface TextPreviewProps {
  content: string;
  fileName: string;
}

export const TextPreview: React.FC<TextPreviewProps> = ({
  content,
  fileName,
}) => {
  // Check if content is JSON for formatting
  const isJson = fileName.endsWith(".json") || fileName.endsWith(".JSON");
  let displayContent = content;

  if (isJson) {
    try {
      const parsed = JSON.parse(content);
      displayContent = JSON.stringify(parsed, null, 2);
    } catch {
      // If parsing fails, just display as-is
    }
  }

  return (
    <div className="h-full min-h-[400px] overflow-auto bg-gray-50 dark:bg-gray-950 p-6">
      <pre className="whitespace-pre-wrap break-words font-mono text-sm text-gray-900 dark:text-gray-100">
        {displayContent}
      </pre>
    </div>
  );
};
